import React from "react";
import { Col, Form, Switch } from "antd";

const RightCol = ({ values, setValues }) => {
  return (
    <Col>
      <Form
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 15,
        }}
      >
        {/* Publish Copilot */}
        <h1 className="h2" style={{ marginLeft: "3rem" }}>
          Publish Copilot
        </h1>

        <Form.Item label="Publish">
          <Switch
            checked={values.publish}
            onChange={(checked) => {
              setValues({
                ...values,
                publish: checked,
              });
            }}
          />
        </Form.Item>
      </Form>
    </Col>
  );
};

export default RightCol;
